import { useState } from "react"

import { Button } from "@/atoms"
import { useHttp } from "@/hooks/useHttp"
import { DownloadOutlined } from "@/icons"
import { downloadFileFromText, downloadFileFromUrl } from "@/services/download"

import styles from "./DownloadFileButton.module.scss"

import type { DownloadFileButtonComponent } from "."

export const DownloadFileButton: DownloadFileButtonComponent = (props) => {
  const { contentEndpoint, query, getText } = props
  const [isGettingText, setIsGettingText] = useState(false)
  const context = useHttp(
    contentEndpoint || "/v1/deployments/download-url",
    query,
    {
      enabled: false
    }
  )

  return (
    <Button
      loading={context.isLoading || isGettingText}
      className={styles.button}
      icon={<DownloadOutlined />}
      onClick={async () => {
        if (getText) {
          setIsGettingText(true)

          try {
            const text = await getText()

            if (text) downloadFileFromText(text, { filename: props.name })
          } catch {
            // getText shows its own error
          } finally {
            setIsGettingText(false)
          }

          return
        }

        let url = props.url
        let template

        if ((!url && query) || contentEndpoint) {
          const { data } = (await context.refetch()) as {
            data?: { data: { downloadUrl: string; template?: string } }
          }

          url = data?.data?.downloadUrl
          template = data?.data?.template
        }

        if (template) downloadFileFromText(template, { filename: props.name })
        else if (url) downloadFileFromUrl({ filename: props.name, url })
      }}
    >
      {props.name}
    </Button>
  )
}
